// 正整数
const positiveInteger = {
  pattern: /^[1-9]\d*$/,
};

// 负整数
const negativeInteger = {
  pattern: /^-[1-9]\d*$/,
};

const npositiveIntegerAndZero = {
  pattern: /^[0-9]*[1-9][0-9]*$/,
};

// 正整数、0
const positiveIntegerAndZero = {
  pattern: /^[1-9]\d*|0$/,
};

// 负整数、0
const negativeIntegerAndZero = {
  pattern: /^-[1-9]\d*|0$/,
};

// 英文字母
const englishChar = {
  pattern: /^[A-Za-z]+$/,
};
// 英文字母 空格
const englishCharAndSpace = {
  pattern: /^[A-Za-z ]+$/,
};
// 大写英文字符
const uppercase = {
  pattern: /^[A-Z]+$/,
};

// 小写英文字符
const lowercase = {
  pattern: /^[a-z]+$/,
};

// 汉字
const chineseChar = {
  pattern: /^[\u4e00-\u9fa5]{0,}$/,
};

// 数字，字母
const numberAndChar = {
  pattern: /^[A-Za-z0-9]+$/,
};
// 数字，字母，空格
const numberAndCharAndSpace = {
  pattern: /^[A-Za-z0-9 ]+$/,
};
// 数字，字母，空格,特殊字符
const numberAndCharAndSpecialEn = {
  pattern: /^[A-Za-z0-9`~!@#$%^&*()_+-<>?:"{},.\\/;'[\] ]+$/,
};
// 数字，字母，下划线
const numberAndCharAndUnderLine = {
  pattern: /^\w+$/,
};

// 手机号码（数字字母和-）
const mobileNumber = {
  pattern: /^[A-Za-z0-9-]+$/,
};

// 电话号码（座机）
const telNumber = {
  pattern: /^[0-9 -]+$/,
};

// 18位身份证号
const cardId2 = {
  pattern: /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/,
};
// 18位身份证号
const cardIdNumber = {
  pattern:
    /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
};
// 原验证置空
const cardId = {
  pattern: /\S/,
};
// qq号
const qq = {
  pattern: /^[1-9][0-9]{4,}$/,
};

// 英文特殊字符
const specialEn = {
  pattern: /^[`~!@#$%^&*()_+<>?:"{},.\\/;'[\]]$/,
};

// 中文特殊字符
const specialCn = {
  pattern: /^[·！#￥（——）：；“”‘、，|《。》？、【】[\]]$/,
};
// 网址
const address = {
  pattern: /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~])+$/,
};
// 数字
const number = {
  pattern: /^[0-9].*$/,
};
// 密码(必须包含大写，小写，数字)
const password = {
  pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]+$/,
};
// 金额(正数，可以有小数点，小数点后最多3位)
const money = {
  pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,6}|[1-9][0-9]*\.\d{1,6}|[1-9][0-9]*\.)))$/,
};
// 金额(正数，可以有小数点，小数点后最多2位)
const percent = {
  // /^\d\.([1-9]{1,1})$|^[1-9]\d(\.\d{1,1}){0,1}$|^100$/
  pattern: /^\d\.([1-9]{1,2})$|^[1-9]\d(\.\d{1,2})?$|^[1-9]$|^100$/,
};

// 金额(正数，可以有小数点，小数点后最多2位,包括0和100)
const bigpercent = {
  pattern: /^[0-9]{1,2}$|^[0-9]{0,2}\.[0-9]{1,2}$|100$/,
};

const mobileNumberNew = {
  pattern: /^[0-9][0-9][0-9]\d{4,11}$/,
};
const mobile = {
  pattern: /^1[345789]\d{9}$/,
};
const bankId = {
  pattern: /^([1-9]{1})(\d{14}|\d{18})$/,
};
const phoneNew = {
  pattern: /^[0-9-]+$/,
};
const phoneNum11 = {
  pattern: /^1\d{10}$/,
};
const newNumber = {
  pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
};
// 10位整数2位小数（小数点后最多两位）
const teenNumber = {
  pattern: /^[0-9]{1,10}$|^[0-9]{1,10}\.[0-9]$|^[0-9]{1,10}\.[0-9]{2}$/,
};
// 18位长度正数（小数点后最多两位）
const eighteenNumber = {
  pattern: /^[0-9]{1,18}$|^[0-9]{0,16}\.[0-9]$|^[0-9]{0,15}\.[0-9]{2}$/,
};
// 18位长度正负数（小数点后最多两位）
const zfEighteenNumber = {
  pattern: /^-?[0-9]{1,18}$|^-?[0-9]{0,16}\.[0-9]$|^-?[0-9]{0,15}\.[0-9]{2}$/,
};
// 18位长度正数（小数点后最多一位）
const eighteenDotOne = {
  pattern: /^[0-9]{1,18}$|^[0-9]{0,16}\.[0-9]$|^[0-9]{0,15}\.[0-9]{1}$/,
};
// 8位长度正负数（小数点后最多两位）
const zfEightNumber = {
  pattern: /^-?[0-9]{1,8}$|^-?[0-9]{0,6}\.[0-9]$|^-?[0-9]{0,5}\.[0-9]{2}$/,
};
// 14位长度正数（小数点后最多两位）
const fourteenNumber = {
  pattern: /^[0-9]{1,14}$|^[0-9]{0,12}\.[0-9]$|^[0-9]{0,11}\.[0-9]{2}$/,
};
// 8位长度正数（小数点后最多两位）
const eightNumber = {
  pattern: /^[0-9]{1,8}$|^[0-9]{0,6}\.[0-9]$|^[0-9]{0,5}\.[0-9]{2}$/,
};
// 6位长度正数（小数点后最多两位）
const sixNumber = {
  pattern: /^[0-9]{1,6}$|^[0-9]{0,4}\.[0-9]$|^[0-9]{0,3}\.[0-9]{2}$/,
};
// 5位长度正数（小数点后最多两位）
const fiveNumber = {
  pattern: /^(0|\+?[1-9][0-9]{0,4})(\.\d{1,2})?$/,
};
// 手机端
const ifPhone = {
  pattern: /(iPhone|iPad|iPod|iOS|Android)/i,
};
//整数6位或者小数点最多2位
const sixOrPointTwo = {
  pattern: /(^[0-9]{1,6}$)|(^[0-9]{1,6}[\.]{1}[0-9]{1,2}$)/,
};
//整数8位和小数点最多2位
const EightOrPointTwo = {
  pattern: /(^[0-9]{1,8}$)|(^[0-9]{1,8}[\.]{1}[0-9]{1,2}$)/,
};

//decimal（8,2）
const neightOrPointTwo = {
  pattern: /^(0|[1-9]\d{0,5})$|^(0|[1-9]\d{0,5})[.]\d{1,2}$/,
};

//decimal（7,2）
const sevenOrPointTwo = {
  pattern: /^(0|[1-9]\d{0,4})$|^(0|[1-9]\d{0,4})[.]\d{1,2}$/,
};

//decimal（3,1）
const threeOrPointone = {
  pattern: /^(0|[1-9]\d{0,1})$|^(0|[1-9]\d{0,1})[.]\d{1,1}$/,
};

//decimal（8,3）
const neightOrPointThree = {
  pattern: /^(0|[1-9]\d{0,4})$|^(0|[1-9]\d{0,4})[.]\d{1,3}$/,
};

//decimal（20,3）
const twentyOrPointThree = {
  pattern: /^(0|[1-9]\d{0,16})$|^(0|[1-9]\d{0,16})[.]\d{1,3}$/,
};
//正整数，最多11位
const elevenNoo = {
  pattern: /^[1-9]\d{0,10}$/,
};

//0和11位正整数
const eleven = {
  pattern: /^(0|[1-9]\d{0,10})$/,
};

//支付宝账号
const AlipayAccount = {
  pattern: /^(?:\w+\.?)*\w+@(?:\w+\.)+\w+|\d{9,11}$/,
};
//微信账号
const WechatAccount = {
  pattern: /^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/,
};

export default {
  positiveInteger,
  negativeInteger,
  positiveIntegerAndZero,
  npositiveIntegerAndZero,
  negativeIntegerAndZero,
  englishChar,
  uppercase,
  lowercase,
  chineseChar,
  numberAndChar,
  numberAndCharAndSpace,
  numberAndCharAndUnderLine,
  mobileNumber,
  telNumber,
  number,
  cardId,
  cardId2,
  qq,
  specialEn,
  specialCn,
  address,
  password,
  money,
  percent,
  bigpercent,
  englishCharAndSpace,
  numberAndCharAndSpecialEn,
  mobileNumberNew,
  cardIdNumber,
  mobile,
  phoneNew,
  bankId,
  teenNumber,
  zfEighteenNumber,
  zfEightNumber,
  fourteenNumber,
  eightNumber,
  sixNumber,
  fiveNumber,
  eighteenDotOne,
  ifPhone,
  sixOrPointTwo,
  EightOrPointTwo,
  neightOrPointTwo,
  sevenOrPointTwo,
  threeOrPointone,
  neightOrPointThree,
  twentyOrPointThree,
  eleven,
  phoneNum11,
  eighteenNumber,
  AlipayAccount,
  WechatAccount,
  newNumber,
  elevenNoo,
};
